// Animation
export const isPageAnimationEnabled = true;


// Login Page Style
export const isDefaultStyle = true; // true or false


//Images
export const logoPath = "lghor.png";


//Pendo Analytics
export const pendoKey = process.env.VUE_APP_PENDO_API_KEY;
export const sponsorName = "Longboat";
export const studyURL = "consent.longboat.com";
export const studyId = "LBDEMO";
export const AppType = "CN";
export const pendoAccountName = studyId + '_' + AppType;


// Authentication
export const password = String(process.env.VUE_APP_PASSWORD)
export const passwordReview = String(process.env.VUE_APP_REVIEW_PASSWORD)
export const cookieExpiryTimeInMins = 10


// i18n localisation configuration
export const defaultLocale = "en";
export const supportedLocales = {
    en: "English UK",
    /*
    es: "Español",
    bd: "Belgisch-Nederlands",
    bd: "Belgisch-Nederlands",
    ck: "傳統中文",
    cs: "Čeština",
    ct: "繁體中文",
    de: "Deutsch",
    el: "ελληνικα",
    fc: "Français canadien",
    fr: "Français",
    hu: "Magyar",
    it: "Italiano",
    ko: "한국어",
    lp: "Español latinoamericano",
    ms: "Melayu",
    nl: "Nederlands",
    pl: "Polski",
    pt: "Português",
    ro: "Română",
    ru: "Русский",
    sp: "Español-EE.UU",
    th: "ไทย",
    zh: "简体中文",
    */
}